<template>

  <!-- --------------------------------------------------------- -->
  <!-- ---------------- Page Header ----------------------------- -->
  <!-- --------------------------------------------------------- -->

  <div class="mainPageDiv">

    <div class="pageHeader">
      Agency
    </div>

    <span class="subHeaderFont">Create New Agency:</span>

    <div @click="handleCreateRecord" 
         class="material-icons forIconNewRecord text-success" 
         data-tooltip="tooltip"
         title="Create a new Agency">
      add_card
    </div>

    <div class="radioheaderadjustment radioFirstLeftMargin">
      <input 
        type="radio" 
        id="radioActiveButtonID" 
        name="agencyState"
        @click="handleActiveRadioClick"
        aria-label="Show Active Users"
        checked />

      <label class="lableMargin subHeaderFont" for="setup">Active</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin">
      <input 
              type="radio" 
              @click="handleAllRadioClick" 
              id="radioAllButtonID" 
              name="agencyState"
             aria-label="Show All Users"/>
      <label class="lableMargin subHeaderFont" for="setup">All</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin">
      <ExcelComp :Data="dataObj"></ExcelComp>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <ApplicationGrid 
             :GridData="gridTime" 
             RowsPerPageText="Agency Records"
             SearchText="Search Agency Records:"
             :EnablePaging="true" 
             :EnableSearching="true" 
             :EnableSorting="true"
             :HeaderArrays="headerArrays" 
             :LeftRightSlots="leftRightSlots"
             :RowsPerPageArray="rowsPerPageArray" 
             :EnableSettings="false"
             :EnableRecordsInfoDisplay="true">

        <!-- ------------------------------------------------------------------------------- -->
        <!-- -------------- RIGHT Email Verified (rightHeader10/rightData10) --------------- -->
        <!-- ------------------------------------------------------------------------------- -->
  
        <template v-slot:rightHeader10>
          <span class="actionsHeader" >Active</span>
        </template>
  
        <template v-slot:rightData10="slotArgs">
  
            <div class="activeAgency"
                 :id="'Agency1_' + slotArgs.itemArg['agency_ID']"
                 data-tooltip="tooltip"
                 title="Click to toggle Active status">

                <input type="checkbox"
                       class="form-check-input"
                       :checked="slotArgs.itemArg['isActive']"
                       value="" aria-label="Check this box to make the record active"
                       @click="handleActiveLinkClick(slotArgs)">
             
            </div>
  
        </template>
  
        <!-- ------------------------------------------------------------------------ -->
        <!-- -------------- RIGHT Action (rightHeader11/rightData11) ---------------- -->
        <!-- ------------------------------------------------------------------------ -->
  
        <template v-slot:rightHeader11>
          <span class="actionsHeader" >Edit</span>
        </template>
  
        <template v-slot:rightData11="slotArgs">
  
          <span @click="handleEditRecord(slotArgs)" 
                class="material-icons text-primary editIconSlot"
                data-tooltip="tooltip" 
                title="Edit Record">
            edit
          </span>
  
        </template>

        <!-- ------------------------------------------------------------------------------- -->
        <!-- -------------- SLOT END ------------------------------------------------------- -->
        <!-- ------------------------------------------------------------------------------- -->

    </ApplicationGrid>
  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL Update-Create start ------------------------ -->
  <!-- ------------------------------------------------------------------------------ -->

  <div id="xmodal-main-ID" class="xmodal-container-main">
    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary headerMainContainer">
        <div style="display: inline-block;">&nbsp;</div>
        <div style="color: white; display: inline-block">{{ modalTitle }}</div>
        <div class="cancelModalX" @click="CloseModalUpdateCreate" style="margin-right: 10px; color: white; display: inline-block; text-align: right; align-items: end;">X</div>
      </div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">
        <!-- ------- Record Id -->
        <div v-if="createSelected == false" id="recId" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Database Record ID">Record Id</div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="agencyIDTxtBx" aria-labelledby="recId" v-model="agencyId" type="text" size="9" disabled />
        </div>
        <!-- ------- Agency Name -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Agency Name" id="agName">
          Agency Name:<span v-if="nameUndefined || nameNotUnique" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="NameTxtBx" v-model="agencyName" type="text" size="50" aria-labelledby="agName" />
        </div>

        <!-- ------- Agency Acronym -->
        <div class="xmodal-content-justify-right xmodal-control-labels" id="agAcr" data-tooltip="tooltip" title="Agency Acronym">
          Agency Acronym:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="agencyAcronym" type="text" size="20" aria-labelledby="agAcr" />
        </div>

        <!-- ------- Active Radio Buttons -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Arming Authority Acronym">
          Active:<span v-if="activeNotSelected" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <input type="radio" :checked="((isActive == true) && (createSelected == false))" id="radioActiveAgencyID"
            name="activeRadioButtons" class="vertAlignMiddle" />

          <label class="labelAlign" for="radioActiveAgencyID">Yes</label>

          <input type="radio" :checked="((isActive == false) && (createSelected == false))" id="radioInactiveAgencyID"
            name="activeRadioButtons" class="vertAlignMiddle radioButtonLeftMargin" />

          <label class="labelAlign" for="radioInactiveAgencyID">No</label>

        </div>

        <!-- ------- Arming Authority list -->
        <div v-if="createSelected == false" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Arming Authority Acronym">
          Last Updated:<span v-if="armingAuthorityAcronymUndefined"
            class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <span>{{ updateDate }}</span>
        </div>

      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <hr v-if="validationErrorsFound" class="xmodal-hr-bottom" />
      <div v-if="validationErrorsFound" class="text-danger xmodal-outer-div">Required fields indicated by asterisk(s).
        Make selections for the following:
        <div class="xmodal-inner-div">
          <ul class="xmodal-li-validation">
            <li v-if="nameUndefined"> Agency Name </li>
            <li v-if="nameNotUnique"> Agency Name already exists </li>
            <li v-if="activeNotSelected"> Please specify whether or not the Agency is Active </li>
          </ul>
        </div>
      </div>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-footer">
        <button type="button" @click="CloseModalUpdateCreate"
          class="btn-danger">
          Cancel
        </button>
        <button id="xmodal-submit-btn-id" type="button" @click="handleEditClickSubmitBtn"
          class="btn-primary">
          Submit
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import { store } from "../../../store/store.js";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue"
import ExcelComp from "../../../components/dataSupport/ExcelComp.vue"

export default {
  data() {
    return {
      store,

      agencyAcronym: null,
      isActive: null,
      activeNotSelected: false,
      agencyId: null,
      agencyState: 'active',
      createSelected: false,
      gridTime: { grid: null, time: null },
      dataObj: {},
      gridAgencyNames: null,
      agencyName: null,
      nameUndefined: false,
      nameNotUnique: false,
      modalTitle: null,
      rowsPerPageArray: [10, 25, 50, 100, 250],
      updateDate: null,
      validationErrorsFound: false,

      headerArrays: [
        { defaultShow: true, rawName: 'agencyId', displayName: 'Agency ID', hoverText: 'Agency database primary key' },
        { defaultShow: true, rawName: 'agencyName', displayName: 'Agency Name', hoverText: 'Name of the Agency' },
        { defaultShow: true, rawName: 'agencyAcronym', displayName: 'Agency Acronym', hoverText: 'Acronym for Agency' },
        // { defaultShow: false, rawName: 'isActive', displayName: 'Active Status', hoverText: 'Active Status' },
        { defaultShow: true, rawName: 'createDate', displayName: 'Create Date', hoverText: 'Date of creation' },
        { defaultShow: true, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Date last updated' },
        { defaultShow: true, rawName: 'createdBy', displayName: 'Create By', hoverText: 'ID of Create By User' },
        { defaultShow: true, rawName: 'updateBy', displayName: 'Update By', hoverText: 'ID of Udate By User' }
      ],

      excelHeader: [
        { defaultShow: true, rawName: 'agencyId', displayName: 'Agency ID', hdrAlignment: 'center', dataAlignment: 'center'},
        { defaultShow: true, rawName: 'agencyName', displayName: 'Agency Name', hdrAlignment: 'left', dataAlignment: 'left'},
        { defaultShow: true, rawName: 'agencyAcronym', displayName: 'Agency Acronym', hdrAlignment: 'left', dataAlignment: 'left'},
        { defaultShow: true, rawName: 'createDate', displayName: 'Create Date', hdrAlignment: 'center', dataAlignment: 'center'},
        { defaultShow: true, rawName: 'updateDate', displayName: 'Update Date', hdrAlignment: 'center', dataAlignment: 'center'},
        { defaultShow: true, rawName: 'createdBy', displayName: 'Create By', hdrAlignment: 'center', dataAlignment: 'center'},
        { defaultShow: true, rawName: 'updateBy', displayName: 'Update By', hdrAlignment: 'center', dataAlignment: 'center'},
      ],
  
        //leftHeader0,   ..., leftHeader9
        //rightHeader10, ..., rightHeader19
        leftRightSlots: [
          { slot: 'rightHeader10', enableSorting: true, field: 'isActive'},
          { slot: 'rightHeader11', enableSorting: true, field: '__not_specified__'},
        ],

    };
  },
  created() {

    this.getAgencies();

  },
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null 
      ? store.authenticatedUser.userProfileId
      : store.tempUserProfileId;
    }, 
  },
  components: { ApplicationGrid, ExcelComp},
  methods: {

    clearValidationFields() {
      this.$data.nameUndefined = false;
      this.$data.nameNotUnique = false;
      this.$data.validationErrorsFound = false;
      this.$data.activeNotSelected = false;
    },

    CloseModalUpdateCreate() {
      // console.log("OpenModalFnc()");
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
    },

    databaseCreateAgency() {
      //Using a flag value such as the following avoids issues with
      //passing blank values in a query string.
      if (this.$data.agencyAcronym == null) {
        this.$data.agencyAcronym = "__null__";
      } else if (this.$data.agencyAcronym.trim().length == 0) {
        this.$data.agencyAcronym = "__null__";
      }

      let activeYes = document.querySelector('#radioActiveAgencyID');
      let localActive = null;
      if (activeYes.checked) {
        localActive = true;
      } else {
        localActive = false;

      }

      axios
        .post(store.webAPIUrl + "Agency/CreateAgency/" +
          this.UserProfileId + '/' +        
          this.$data.agencyName + "/" +
          this.$data.agencyAcronym + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getAgencies();
        });
    },

    databaseUpdateAgency() {

      //Using a flag value such as the following avoids issues with
      //passing blank values in a query string.
      if (this.$data.agencyAcronym == null) {
        this.$data.agencyAcronym = "__null__";
      } else if (this.$data.agencyAcronym.trim().length == 0) {
        this.$data.agencyAcronym = "__null__";
      }

      let activeYes = document.querySelector('#radioActiveAgencyID');
      let localActive = null;
      if (activeYes.checked) {
        localActive = true;
      } else {
        localActive = false;
      }

      axios
        .post(store.webAPIUrl + "Agency/UpdateAgency/" +
          this.UserProfileId + '/' +
          this.$data.agencyId + "/" +
          this.$data.agencyName + "/" +
          this.$data.agencyAcronym + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getAgencies();
        });
    },

    //Used to format dates passed to the HTML date control.
    formatDateFnc(value) {
      let monthPart = value.substring(0, 2);
      let dayPart = value.substring(3, 5);
      let yearPart = value.substring(6, value.length);
      return monthPart + '/' + dayPart + '/' + yearPart;
    },

    getAgencies() {

      axios
        .get(store.webAPIUrl + "Agency/SelAgencies/" + this.$data.agencyState)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };

          this.$data.dataObj.dataGrid = new Array();
          this.$data.dataObj.headerArray = new Array();
          this.$data.dataObj.dataGrid = data;
          this.$data.dataObj.headerArray = this.$data.excelHeader;

          //This has to be updated for validation.
          this.getAgencyNumbers();
        });
    },

    getAgencyNumbers() {
      axios
        .get(store.webAPIUrl + "Agency/SelAgencyNames")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridAgencyNames = data;
          // console.log(' ---> this.$data.gridAgencyNames = ', this.$data.gridAgencyNames);
        });
    },

    //This is called in response to clicking the Active/Inactive links.
    handleActiveLinkClick(args) {

      let agency_id = args.itemArg["agencyId"];
      // let ctrlControlID = 'Agency_' + agency_id;

      // console.log('args.itemArg["isActive"] = ', args.itemArg["isActive"]);
      // console.log('args.itemArg["agencyId"] = ', args.itemArg["agencyId"]);
      // console.log('ctrlControlID = ', ctrlControlID);

      let newActive = false;
      if (args.itemArg["isActive"] == false) {
        newActive = true;
      }

      // console.log('newActive = ', newActive);

      this.UpdateAgencyActive(agency_id, newActive);

    },

    handleActiveRadioClick() {
      this.$data.agencyState = 'active';

      this.getAgencies();
    },

    handleAllRadioClick() {
      this.$data.agencyState = 'all';

      this.getAgencies();
    },

    //This is called in response to clicking the create div.The dialog
    //modal is opened due to properties set in the edit div. 
    handleCreateRecord() {
      // console.log('-->> handleCreateRecord()');
      this.$data.createSelected = true;
      this.clearValidationFields();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveAgencyID');
      let noRadioButton = document.querySelector('#radioInactiveAgencyID');

      yesRadioButton.checked = false;
      noRadioButton.checked = false;

      this.$data.modalTitle = 'Create Agency Record';

      this.$data.agencyName = null;
      this.$data.agencyAcronym = null;

    },

    //This method is called when clicking on the submit button
    //in the update modal.
    handleEditClickSubmitBtn() {

      this.validateFields();

      if (this.$data.validationErrorsFound == false) {

        let modalWindow = document.querySelector("#xmodal-main-ID");
        modalWindow.style.display = "none";

        if (this.$data.createSelected == true) {
          this.databaseCreateAgency();
        } else {
          this.databaseUpdateAgency();
        }
      }

    },

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleEditRecord(args) {

      this.$data.createSelected = false;
      this.clearValidationFields();

      //These will be used the modal window.
      this.$data.agencyId = args.itemArg["agencyId"];
      this.$data.agencyName = (args.itemArg["agencyName"]).trim();

      this.$data.agencyAcronym = (args.itemArg["agencyAcronym"] != null) ? (args.itemArg["agencyAcronym"]).trim() : args.itemArg["agencyAcronym"];

      this.$data.isActive = args.itemArg["isActive"];

      this.$data.updateDate = args.itemArg["updateDate"];
      if (this.$data.updateDate) {
        this.$data.updateDate = this.formatDateFnc(this.$data.updateDate);
      }

      this.$data.modalTitle = 'Edit Agency Record';

      // console.log('this.$data.isActive = ', this.$data.isActive);

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveAgencyID');
      let noRadioButton = document.querySelector('#radioInactiveAgencyID');

      if (this.$data.isActive == true) {
        yesRadioButton.checked = true;
        noRadioButton.checked = false;
      } else {
        yesRadioButton.checked = false;
        noRadioButton.checked = true;
      }

    },

    UpdateAgencyActive(agencyId, agencyState) {
      axios
        .get(store.webAPIUrl + "Agency/UpdateAgencyActive/" + this.UserProfileId + '/' + agencyId + '/' + agencyState)
        .then((response) => response.data)
        .then(() => {
          this.getAgencies();
        });
    },

    validateActiveState() {
      let yesRadioButton = document.querySelector('#radioActiveAgencyID');
      let noRadioButton = document.querySelector('#radioInactiveAgencyID');

      if ((yesRadioButton.checked == false) && (noRadioButton.checked == false)) {
        this.$data.validationErrorsFound = true;
        this.$data.activeNotSelected = true;
      }

    },

    validateagencyName() {

      // console.log('this.$data.agencyName = ', this.$data.agencyName);

      if (this.$data.agencyName == null) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else if (this.$data.agencyName.trim().length == 0) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else {

        for (let i = 0; i < this.$data.gridAgencyNames.length; i++) {
          let agencyName = this.$data.gridAgencyNames[i]['agencyName'];
          let agencyID = this.$data.gridAgencyNames[i]['agencyId'];

          let trimmedOriginalName = agencyName.trim().toLowerCase();
          let trimmedNewName = this.$data.agencyName.trim().toLowerCase();

          if (this.$data.createSelected == false) {
            if ((trimmedOriginalName === trimmedNewName) && (this.$data.agencyId != agencyID)) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          } else {
            if (trimmedOriginalName === trimmedNewName) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          }

        }
      }

    },

    validateFields() {

      this.clearValidationFields();

      this.validateagencyName();

      if (this.$data.createSelected == true) {
        this.validateActiveState();
      }
    },

  },
};
</script>

<style scoped>
/* ----------------- page ------------------------ */

.itemCenterCenter {
    display: flex; 
    align-items: center;
    justify-content: center;
}

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.vertAlignMiddle {
  vertical-align: middle;
}

.radioButtonLeftMargin {
  margin-left: 10px;
}

.labelAlign {
  vertical-align: middle;
  padding: 0px;
  margin: 0px;
  padding-left: 5px;
}

/* -----------------  slots ------------------------ */

.activeAgency {
  margin-left: 20px;
  display: inline-block;
}

.activeInactiveString{
  display: inline-block; 
  width: 50px;
}

.spanLink {
  text-decoration: underline;
  cursor: pointer;
}

.editIconSlot {
  margin: 0px;
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  cursor: pointer;
}

.actionsHeader {
  padding: 0px;
  margin: 0px;
  margin-left: 0px;
}

/* --------------- page header ----------- */

.subHeaderFont {
  font-size: 18px;
}

.pageHeader {
  font-size: 24px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.lableMargin {
  margin-left: 5px;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

.cancelButton {
  background: #6d757c;
  color: white;
  border-radius: 6px;
  margin-left: 10px;
  cursor: pointer;
}
 
.cancelButton:Hover {
  background: #4e5257;
  color: white;
}

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.headerMainContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 10% 80% 10%;
}

.cancelModalX {
  cursor: pointer;
}

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 35% 65%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 25%;
  height: 45%;

  min-height: 400px;
  max-height: 400px;

  min-width: 900px;
  max-width: 1000px;

  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-title {
  text-align: left;
  margin-left: 10px;
  font-size: x-large;
}

.xmodal-footer {
  text-align: center;
}

/* ---------- buttons ---------- */

.xmodal-button-Radius {
  border-radius: 6px;
}

/* **** cancel btn */

.xmodal-cancelButton {
  cursor: pointer;
}

/* **** submit btn */

.xmodal-yesSubmitButton {
  margin-left: 10px;
  cursor: pointer;
}

.xmodal-yesSubmitButton:hover {
  background-color: rgb(19, 64, 0);
  color: white;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- validation ---------- */

.xmodal-outer-div {
  margin: 5px;
  display: grid;
  grid-template-columns: 80%;
  align-items: center;
  justify-content: center;
}

.xmodal-inner-div {
  margin: 0 auto;
}

.xmodal-li-validation {
  text-align: left;
  margin-top: 15px;
  color: black;
  width: 400px;
}

.xmodal-required-asterisk {
  margin-left: 2px;
  font-size: x-large;
}

/* ---------- content elements ---------- */

.xmodal-textbox-padding {
  padding: 5px;
}

.xmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgb(2, 2, 175);
}

.xmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */
</style>
